<template>
  <div :class="['guided-field', { 'guided-field--wide': wide }]">
    <span>{{ label }}<b v-if="required"> *</b></span>
    <div class="guided-field__control">
      <slot />
    </div>
    <small v-if="hint">{{ hint }}</small>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string
  hint?: string
  required?: boolean
  wide?: boolean
}>()
</script>

<style scoped lang="scss">
.guided-field { min-width: 0; display: flex; flex-direction: column; gap: 6px; }
.guided-field--wide { grid-column: 1 / -1; }
.guided-field > span { color: var(--jf-color-text-secondary); font-size: 12px; font-weight: 700; line-height: 1.4; }
.guided-field > span b { color: var(--jf-color-error); }
.guided-field__control { min-width: 0; }
.guided-field > small { min-height: 17px; color: var(--jf-color-text-secondary); font-size: 12px; line-height: 1.45; }
@media (max-width: 760px) {
  .guided-field--wide { grid-column: auto; }
}
</style>
